<template>
  <div>
    <!-- Integrations section start -->
    <section class="home-section-04" v-if="!isLegalPage">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="integration-logos">
            <router-link :to="{ name: 'integration-fortnox' }" class="logo-link">
              <img
                src="@/assets/mainImages/fortnox-integrationspartner2.png"
                alt="Fortnox"
                class="main"
              />
            </router-link>
            <router-link :to="{ name: 'integration-spiris' }" class="logo-link">
              <img
                src="@/assets/mainImages/spiris.png"
                alt="Spiris"
                class="main spiris-logo"
              />
            </router-link>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="text" style="margin: 0 15px">
            <h4>
              {{ $t("FooterLayoutFirst.header") }}
            </h4>
            <p>
              {{ $t("FooterLayoutFirst.subtitle") }}
            </p>
            <div class="item">
              <div class="icon">
                <img src="@/assets/mainImages/icons/i01.svg" alt="" />
              </div>

              <p>
                {{ $t("FooterLayoutFirst.list.firstList") }}
              </p>
            </div>

            <div class="item">
              <div class="icon">
                <img src="@/assets/mainImages/icons/i02.svg" alt="" />
              </div>

              <p>{{ $t("FooterLayoutFirst.list.secondList") }}</p>
            </div>

            <div class="item">
              <div class="icon">
                <img src="@/assets/mainImages/icons/i01.svg" alt="" />
              </div>

              <p>{{ $t("FooterLayoutFirst.list.thirdList") }}</p>
            </div>

            <div class="integration-links">
              <router-link :to="{ name: 'integration-fortnox' }" class="button">
                {{ $t("FooterLayoutFirst.list.fortnoxLink") }}
                <img src="@/assets/mainImages/icons/arrow-right-blue.svg" alt="" />
              </router-link>
              <router-link :to="{ name: 'integration-spiris' }" class="button">
                {{ $t("FooterLayoutFirst.list.spirisLink") }}
                <img src="@/assets/mainImages/icons/arrow-right-blue.svg" alt="" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Integrations section End -->
    <!-- Footer -->
    <footer class="mainfooter">
      <div class="container">
        <div class="row mx-2">
          <div class="col-lg-6">
            <a href="# " class="logo">
              <img src="@/assets/mainImages/Autofaktura6.png" alt=""
            /></a>
            <p class="description">
              {{ $t("FooterLayoutFirst.description") }}
            </p>
          </div>

          <div class="col-lg-3">
            <ul class="menu">
              <h4>{{ $t("FooterLayoutFirst.headerLink") }}</h4>
              <li v-for="(link, index) in dataLink" :key="index">
                <a v-if="link.key !== 'terms_of_purchase'" :href="link.route">
                  {{ link.label }}
                </a>
                <!-- <a download="AUTOFAKTURA TERMS OF PURCHASE"
                  v-else
                  href="../../AUTOFAKTURA_TERMS_OF_PURCHASE.pdf"
                >
                  {{ link.label }}
                </a> -->
              </li>
            </ul>
          </div>
          <div class="col-lg-12">
            <span class="copyright"> Connectivo AB </span>
          </div>
          <br />
          <div class="col-lg-12">
            <span class="copyright">
              © {{ new Date().getFullYear() }} AutoFaktura.
              {{ $t("AppFooter.reserved") }}
            </span>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer End -->
  </div>
</template>

<script>
export default {
  computed: {
    isLegalPage() {
      const p = (this.$route && this.$route.path) || "";
      return p.startsWith("/legal");
    },
  },
  data() {
    return {
      dataLink: this.$t("FooterLayoutFirst.link"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/firstlayout/footer.scss";
</style>
